"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MealVkusvillVlmlFilled = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MealVkusvillVlmlFilled = function MealVkusvillVlmlFilled(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.414 8h1.29v3.664h-1.29V8zm9.694 12.3a10.216 10.216 0 011.152 4.743 10.12 10.12 0 01-2.486 6.666h7.505V33H4.856v-1.29h7.473a10.216 10.216 0 1116.78-11.41zm4.289 4.072l-.013 1.292 3.664.036.013-1.29-3.664-.038zM3 24.446l3.664-.048.016 1.29-3.664.05L3 24.445zm31.491-8.474l-3.172 1.833.646 1.118 3.172-1.833-.646-1.118zm-8.302-2.841l1.834-3.172 1.118.646-1.834 3.172-1.118-.646zM12.09 9.96l-1.118.646 1.832 3.172 1.118-.645L12.09 9.96zm-7.123 7.115l.646-1.118 3.172 1.833-.645 1.118-3.173-1.833z",
    fill: "#97BA1E"
  }));
};

exports.MealVkusvillVlmlFilled = MealVkusvillVlmlFilled;
var _default = MealVkusvillVlmlFilled;
exports.default = _default;